




import { defineComponent } from '@vue/composition-api';
import { useIdle, whenever } from '@vueuse/core';
import { millisecondsInSecond } from 'date-fns/constants';
import ModalMessage from '@/components/ModalMessage.vue';
import { logger } from '@/logger';
import { useAuthStore } from '@/stores/auth';

export default defineComponent({
  props: {
    // time before the idle modal is shown in seconds
    timeout: {
      type: Number,
      default: 60,
    },
    // time modal is shown before logout in seconds
    modalTimeout: {
      type: Number,
      default: 10,
    },
  },
  setup(props, { root }) {
    const authStore = useAuthStore();

    const { idle, reset } = useIdle(props.timeout * millisecondsInSecond);
    const { idle: showModal } = useIdle(
      (props.timeout - props.modalTimeout) * millisecondsInSecond,
    );

    whenever(
      () => !root.$route.meta?.allowUnauthorized && showModal.value === true,
      () =>
        root.$modal.show(
          ModalMessage,
          {
            title: 'Let op',
            bodyText:
              'Je bent al een tijdje inactief. Je zal in een ogenblik worden uitgelogd.',
            primaryText: 'Ik ben er nog!',
            primaryIcon: false,
            primaryCallback: reset,
          },
          {
            name: 'idleModal',
            width: 600,
            height: 'auto',
          },
        ),
      { immediate: true },
    );

    whenever(
      () => !root.$route.meta?.allowUnauthorized && idle.value === true,
      () => {
        root.$modal.hide('idleModal');
        logger.warn('Logout due to inactivity');
        root.$modal.show(ModalMessage, {
          title: 'Let op',
          bodyText: 'Je bent automatisch uitgelogd door inactiviteit.',
          primaryText: 'OK',
          primaryIcon: false,
          primaryCallback: () =>
            authStore
              .logout()
              .finally(() => root.$router.push({ name: 'Login' })),
        });
      },
      { immediate: true },
    );
  },
});
